export default __webpack_public_path__ + "static/media/school-bus-tracking.646f6416.png";